<template>
  <div class="chartWrapper">
    <column-chart :data="chartData" :colors="color"></column-chart>
  </div>
</template>

<script>
import mapGettersMixin from '../../../mixins/mapGettersMixin'
import axios from '../../../../axios'

export default {
  name: 'WorkloadOverview',
  components: {},
  mixins: [mapGettersMixin],
  data() {
    return {
      color: ['#8b69a9'],
      fetchedData: [],
      userHours: {},
      chartData: []
    }
  },
  mounted() {
    this.fetchAndCalculate()
  },

  methods: {
    async fetchAndCalculate() {
      await this.fetchWorkReportsHours()
      this.calculateTotalHoursPerUser()
      this.chartData = Object.entries(this.userHours)
    },
    async fetchWorkReportsHours() {
      const responseProjectId = await this.getProjectId
      const params = {
        params: {
          project_id: responseProjectId
        }
      }
      const responseWorkReportsHours = await axios.get('work-report-hours', params)
      this.fetchedData = responseWorkReportsHours.data
    },
    calculateTotalHoursPerUser() {
      this.fetchedData.map((item) => {
        const name = `${item.author.first_name}, ${item.author.last_name}`
        if (!(name in this.userHours)) {
          this.userHours[name] = item.task_duration
        } else if (name in this.userHours) {
          this.userHours[name] += item.task_duration
        }
      })
    }
  }
}
</script>

<style>
.chartWrapper {
}
</style>
